import React from 'react';
import { Box } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import { getTablePreferences, setTablePreferences } from 'components/utils';
import { sendApiRequest } from 'lib/api/public';

const iconStyle = {
  cursor: 'pointer',
};

type SorterProps = {
  tableName: string;
  title: string;
  columnName: string;
  onSort: (columnName: string) => void;
};

const Sorter = ({ tableName, title, columnName, onSort }: SorterProps) => {
  const { sortField, sortDirection } = getTablePreferences(tableName);

  const handleClick = (event: React.MouseEvent<SVGSVGElement>) => {
    event.stopPropagation();
    const newSortDirection = sortDirection === 'desc' ? 'asc' : 'desc';

    setTablePreferences({
      tableName,
      values: [
        {
          key: 'sortField',
          value: columnName,
        },
        {
          key: 'sortDirection',
          value: newSortDirection,
        },
      ],
    });

    onSort(columnName);

    sendApiRequest({
      path: '/users/save-table-preferences',
      data: {
        tableName,
        preferences: [
          {
            key: 'sortField',
            value: columnName,
          },
          {
            key: 'sortDirection',
            value: newSortDirection,
          },
        ],
      },
    })
      .then(() => {
        console.log('Table preferences saved');
      })
      .catch(err => {
        console.error(err.message);
      });
  };

  let arrow = <SwapVertIcon sx={iconStyle} onClick={handleClick} fontSize="small" />;

  if (sortField === columnName) {
    if (sortDirection === 'asc') {
      arrow = <ArrowDropUpIcon sx={iconStyle} onClick={handleClick} />;
    } else {
      arrow = <ArrowDropDownIcon sx={iconStyle} onClick={handleClick} />;
    }
  }

  return (
    <Box sx={{ alignItems: 'center', display: 'flex' }}>
      {title} {arrow}
    </Box>
  );
};

export default Sorter;
